module.exports = __webpack_public_path__ + "media/img/marquee/marquee-solutions-banner-d029a5124001415ca0a7a104a5a788a2.jpg";